import React,{useState} from 'react'
import useAuth from '../../hooks/useAuth'
import image1 from './image/banner1.png'
import image2 from './image/banner2.png'
import image3 from './image/banner3.png'
import image4 from './image/banner4.png'
import image5 from './image/delta.png'
import image6 from './image/feature_3.png'
import image7 from './image/image2.png'
import image8 from './image/image3.png'
import image9 from './image/nokia-air.png'
import image10 from './image/nokia.png'
import image11 from './image/one.png'
import image12 from './image/watch.png'

function Cards() {
	const{count,setCount}=useAuth()

	const data=[
		{
			id:1,
			name:"T-Shirt",
			img:image1,
			price:45,
			quantity:1,

		},
		{
			id:2,
			name:"Kurti",
			img:image2,
			price:40,
			quantity:1,

		},
		{
			id:3,
			name:"Shoes",
			img:image3,
			price:50,
			quantity:1,

		},
		{
			id:4,
			name:"Watch",
			img:image4,
			price:30,
			quantity:1,

		},
		{
			id:5,
			name:"Boot",
			img:image5,
			price:55,
			quantity:1,

		},
		{
			id:6,
			name:"Shoes",
			img:image6,
			price:35,
			quantity:1
		},
		{
			id:7,
			name:"Sandles",
			img:image7,
			price:45,
			quantity:1,

		},
		{
			id:8,
			name:"Shoes",
			img:image8,
			price:40,
			quantity:1,

		},
		{
			id:9,
			name:"H Phone",
			img:image9,
			price:25,
			quantity:1,

		},
		{
			id:10,
			name:"S Phone",
			img:image10,
			price:75,
			quantity:1,

         

		},
		{
			id:11,
			name:"M Phone",
			img:image11,
			price:60,
			quantity:1,

		},
		{
			id:12,
			name:"Watch",
			img:image12,
			price:40,
			quantity:1,

		},
	]
	const [item,setItem]=useState(data)

	let span = document.getElementsByTagName('span');
	let product = document.getElementsByClassName('product')
	let product_page = Math.ceil(product.length/4);
	let l = 0;
	let movePer = 25.34;
	let maxMove = 203;
	// mobile_view	
	let mob_view = window.matchMedia("(max-width: 768px)");
	if (mob_view.matches)
	 {
	 	movePer = 50.36;
	 	maxMove = 504;
	 }

	let right_mover = ()=>{
		l = l + movePer;
		if (product == 1){l = 0; }
		for(const i of product)
		{
			if (l > maxMove){l = l - movePer;}
			i.style.left = '-' + l + '%';
		}

	}
	let left_mover = ()=>{
		l = l - movePer;
		if (l<=0){l = 0;}
		for(const i of product){
			if (product_page>1){
				l = l + movePer;
			}
			i.style.left = '-' + l + '%';
		}
		
	}
	// span[1].onClick = ()=>{right_mover();}
	// span[0].onClick = ()=>{left_mover();}
 
	
  return (
    <>
   <main>
		<div class="text">
		
		</div>
		<header>
			<h1>Top Hottest Products</h1>
			<p>
				<span onClick={()=>{left_mover()}}>&#139;</span>
				<span onClick={()=>{right_mover()}}>&#155;</span>
			</p>
		</header>

		<section>
{item.map((value)=>{
	return (
		<div class="product">
				<picture>
					<img src={value.img} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>{value.name}</b><br/>
						<small>New arrival</small>
					</p>
					<samp>${value.price}</samp>
				</div>
				<div class="button">
					<p class="star">
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						
					</p>
					{/* <a href="#cart" onClick={()=>{setCount([value,...count])}}><i class="bi bi-cart-plus-fill "></i></a> */}
	                {count.includes(value) ? (
             <a href="#cart" onClick={() => setCount(count.filter((e)=> e.id !== value.id))} id="remove" className="remove remove-to-cart-btn">
               <i className="bi bi-cart-plus-fill me-1"></i>
           </a>
                
            ) : (
              <a href="#cart" onClick={()=>{setCount([value,...count])}} id="add"><i class="added bi bi-cart-plus-fill "></i></a>
               
            ) }
                                                                            
				</div>
				</div>
	)
})}
		</section>

		{/* <section>
		<div class="product">
				<picture>
					<img src={image1} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Casual Shirt</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
				</div>
			<div class="product">
				<picture>
					<img src={image2} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Kurti</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image3} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Shoes</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image4} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Watch</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image5} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Boot</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image6} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>K Shoes</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image7} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Pumpi</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image8} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Z Shoes</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image9} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>Handfree</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image10} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>N Phones</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image11} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>I Phones</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
			<div class="product">
				<picture>
					<img src={image12} alt=""/>
				</picture>
				<div class="detail">
					<p>
						<b>E Watches</b><br/>
						<small>New arrival</small>
					</p>
					<samp>$45.00</samp>
				</div>
				<div class="button">
					<p class="star">
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
					<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
						<strong><i className="bi bi-star-fill text-warning"></i></strong>
					</p>
					<a href="#"><i class="bi bi-cart-plus-fill "></i></a>
				</div>
			</div>
		</section> */}
	</main>
    </>
  )
}

export default Cards